import { BaseTool } from "../../../base/BaseTool";

export class WorkspaceTool extends BaseTool {
  get appType() {
    return this.toolSystem?.appType || null;
  }

  get fs() {
    return this.toolSystem?.fs || null;
  }

  get git() {
    return this.toolSystem?.git || null;
  }

  get workspaceManager() {
    return this.toolSystem?.workspaceManager || null;
  }

  /**
   * Absolute working directory for local apps (from app.settings.workingDirectoryPath).
   * @returns {string|null}
   */
  getLocalWorkingDirectoryRoot() {
    const raw = this.workspaceManager?.app?.settings?.workingDirectoryPath;
    if (!raw || typeof raw !== "string") return null;
    const t = raw.trim();
    return t.length ? t : null;
  }

  /**
   * Revolt Desktop IPC API for native workspace file operations (`local` app type).
   * @returns {Record<string, Function>|null}
   */
  getWorkspaceLocalAppApi() {
    if (typeof window === "undefined") return null;
    return window.workspaceLocalAppAPI || null;
  }

  /**
   * Normalize and validate a workspace-relative path (no `..`, forward slashes).
   * @param {string} path - Path to normalize
   * @returns {string|null} Path with leading `/` or null if invalid
   */
  normalizeAndValidatePath(path) {
    if (!path || typeof path !== "string") {
      return null;
    }

    let normalized = path.replace(/^\/+/, "");

    if (normalized.includes("..")) {
      return null;
    }

    normalized = normalized.replace(/\\/g, "/");

    return `/${normalized}`;
  }
}
